type Listener = () => void;

let suppressionPanelOpen = false;
const listeners = new Set<Listener>();

export function subscribeToSuppressionPanelPersistence(listener: Listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function isSuppressionPanelPersistent() {
  return suppressionPanelOpen;
}

export function setSuppressionPanelPersistent(open: boolean) {
  if (suppressionPanelOpen === open) return;
  suppressionPanelOpen = open;
  listeners.forEach(listener => listener());
}
